import * as DownloadPurpose from "../constants/DownloadPurpose";
import * as OutputFormat from "../constants/OutputFormat";
import * as ts from "../common/Translator";
import {EmailSenderView} from "./EmailSenderView";
import {registerOnWindowResize} from "../common/NamaCommon";


export class ReportViewer {
    /**
     *
     * @param {ReportViewerPresenter} presenter
     */
    constructor(presenter) {
        this.presenter = presenter;
        this.reportLoaded = false;
    }

    render() {
        let that = this;
        let reportContainer = $(`<div id="iframe_container"><iframe id = "reportIFrame"></iframe></div>`);
        let reportFrame = reportContainer.find("#reportIFrame");
        reportFrame.attr("src", "assets/namasoft/img/loading.html");
        let exampleDiv = that.presenter.embeddedViewContainer || that.presenter.reportContainer;
        if (!that.presenter.embeddedReportView) {
            $("#main-wrapper").find("#example.page-content-wrapper").remove();
            exampleDiv = $(`<div id="example" class="page-content-wrapper"></div>`);
            exampleDiv.appendTo($("#main-wrapper"));
        }
        that.setIFrameDims(reportFrame);
        registerOnWindowResize(reportFrame[0], (e) => {
            that.setIFrameDims(reportFrame);
        });
        reportFrame.appendTo(exampleDiv);
        that.presenter.view = exampleDiv;
        let reportToolbar = $(`<div id="reportToolbar" ></div>`);

        reportToolbar.kendoToolBar({
            resizable: true,
            items: [
                exportButton("exportAsPDF", "assets/namasoft/img/pdf.png", () => that.presenter.onExport(OutputFormat.PDF, DownloadPurpose.DOWNLOAD)),
                exportButton("exportAsDOCX", "assets/namasoft/img/docx.png", () => that.presenter.onExport(OutputFormat.DOCX, DownloadPurpose.DOWNLOAD)),
                exportButton("exportAsRTF", "assets/namasoft/img/rtf.png", () => that.presenter.onExport(OutputFormat.RTF, DownloadPurpose.DOWNLOAD)),
                exportButton("exportAsXLSX", "assets/namasoft/img/xlsx.png", () => that.presenter.onExport(OutputFormat.XLSX, DownloadPurpose.DOWNLOAD)),
                exportButton("exportAsXLS", "assets/namasoft/img/xls.png", () => that.presenter.onExport(OutputFormat.XLS, DownloadPurpose.DOWNLOAD)),
                exportButton("exportAsODT", "assets/namasoft/img/odt.png", () => that.presenter.onExport(OutputFormat.ODT, DownloadPurpose.DOWNLOAD)),
                exportButton("exportAsODS", "assets/namasoft/img/ods.png", () => that.presenter.onExport(OutputFormat.ODS, DownloadPurpose.DOWNLOAD)),
                exportButton("exportAsPPTX", "assets/namasoft/img/pptx.png", () => that.presenter.onExport(OutputFormat.PPTX, DownloadPurpose.DOWNLOAD)),
                exportButton("reportZoomIn", "assets/namasoft/img/zoomin.png", () => that.zoomIfNeeded(reportFrame, true)),
                exportButton("reportZoomOut", "assets/namasoft/img/zoomout.png", () => that.zoomIfNeeded(reportFrame, false)),
                exportButton("reportRelaunch", "assets/namasoft/img/relaunch.png", () => that.presenter.relaunchReport()),
                exportButton("print", "assets/namasoft/img/print.png", () => that.presenter.onExport(OutputFormat.PDF, DownloadPurpose.PRINT)),
                exportButton("sendEmailWithResult", "assets/namasoft/img/mailReport.png", () => that.showReportViaEmailDialog()),
                {template: "<div id='pager'></div>"},]
        });

        reportToolbar.appendTo(exampleDiv);
        reportFrame.on('load', function () {
            if (that.reportLoaded)
                return;
            kendo.resize(reportToolbar);
            reportFrame.attr("src", that.presenter.rptUrl);
            that.reportLoaded = true;
            that.updatePagerData(reportFrame, reportToolbar, exampleDiv);
        });
    }

    setIFrameDims(reportFrame) {
        let that = this;
        let navbarHeight = $(".navbar").height();
        let innerHeight = window.innerHeight;
        that.frameH = innerHeight - navbarHeight - 100;
        if (that.presenter.viewHeight)
            that.frameH = that.presenter.viewHeight - 50;
        that.frameW = window.innerWidth - 20;
        if (that.presenter.viewWidth)
            that.frameW = that.presenter.viewWidth - 50;
        reportFrame.height(that.frameH);
        reportFrame.width(that.frameW);
    }

    updatePagerData(reportFrame, reportToolbar, exampleDiv) {
        let that = this;
        if (that.presenter.place.format !== OutputFormat.HTML)
            return;
        if (!that.reportCompletelyLoaded(reportFrame)) {
            setTimeout(() => {
                that.updatePagerData(reportFrame, reportToolbar, exampleDiv)
            }, 500);
        } else {
            let dataSource = new kendo.data.DataSource({
                data: new Array(that.reportPagesCount(reportFrame)),
                pageSize: 1
            });
            reportToolbar.find("#pager").kendoPager({
                dataSource: dataSource,
                buttonCount: 1,
                info: true,
                change: () => {
                    let pagerData = reportToolbar.find("#pager").data("kendoPager");
                    that.reportGoToPage(reportFrame, pagerData.page())
                }
            });
            dataSource.read();
            kendo.resize(reportToolbar);
            exampleDiv.find(".k-pager-info").css("display", "block");
        }
    }

    zoomIfNeeded(reportFrame, zoomIn) {
        let that = this;
        let zoomStr = null;
        let reportId = that.presenter.place.reportId;
        if (reportId)
            zoomStr = localStorage.getItem(reportId);
        if (!zoomStr)
            zoomStr = localStorage.getItem("namaHTMLZoom");
        let currentZoom = null;
        if (zoomStr) {
            currentZoom = parseInt(zoomStr);
        }
        if (currentZoom == null)
            currentZoom = 100;
        if (zoomIn)
            currentZoom += 10;
        else
            currentZoom -= 10;
        localStorage.setItem("namaHTMLZoom", currentZoom + "");
        if (reportId)
            localStorage.setItem(reportId, currentZoom + "");
        reportFrame[0].contentWindow.zoomIfNeeded(true);
    }

    reportCompletelyLoaded(reportFrame) {
        return reportFrame[0].contentWindow.pagesCount;
    }

    reportPagesCount(reportFrame) {
        return reportFrame[0].contentWindow.pagesCount();
    }

    reportCurrentPage(reportFrame) {
        return reportFrame[0].contentWindow.currentPage();
    }

    reportGoToPage(reportFrame, pageNumber) {
        reportFrame[0].contentWindow.goToPage(pageNumber - 1);
    }


    showReportViaEmailDialog() {
        let that = this;
        new EmailSenderView(that.presenter).show();
    }
}

export function exportButton(id, imgUrl, callback) {
    return {
        type: "button", id: id,
        imageUrl: imgUrl,
        attributes: {
            title: ts.translateId(id),
        },
        click: callback,
    };
}